import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import MPProfile from './pages/MPProfile';
import LatestQuarter from './pages/LatestQuarter';
import News from './pages/News';
import Methodology from './pages/Methodology';
import PlaceholderDataset from './pages/PlaceholderDataset';
import Immigration from './pages/Immigration';
import Disability from './pages/Disability';
import Housing from './pages/Housing';
import TheSqueeze from './pages/TheSqueeze';
import FederalSpendingHundred from './pages/FederalSpendingHundred';
import Inflation from './pages/Inflation';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mp/:slug" element={<MPProfile />} />
          <Route path="/latest-quarter" element={<LatestQuarter />} />
          <Route path="/news" element={<News />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/immigration" element={<Immigration />} />
          <Route path="/disability" element={<Disability />} />
          <Route path="/housing" element={<Housing />} />
          <Route path="/the-squeeze" element={<TheSqueeze />} />
          <Route path="/federal-spending-100" element={<FederalSpendingHundred />} />
          <Route path="/inflation" element={<Inflation />} />
          <Route path="/health-transfer" element={
            <PlaceholderDataset
              slug="health-transfer"
              kicker="Federal transfers"
              title="Canada Health Transfer"
              blurb="The largest federal transfer to provinces and territories. We publish the published figures from Finance Canada, with the provincial allocations and the 12-year trend."
              source="Department of Finance Canada — Federal Support to Provinces and Territories."
            />
          } />
          <Route path="/contracts" element={
            <PlaceholderDataset
              slug="contracts"
              kicker="Federal contracts"
              title="Contracts awarded"
              blurb="Every federal contract notice published by Government of Canada departments at or above $10,000, drawn from the Open Government proactive disclosure feed."
              source="Open Government Canada — Proactive disclosure of contracts (open.canada.ca)."
            />
          } />
          <Route path="/donations" element={
            <PlaceholderDataset
              slug="donations"
              kicker="Political financing"
              title="Donations to federal parties"
              blurb="Contributions declared to Elections Canada under the Canada Elections Act. Each receipt above the disclosure threshold is published with donor name, recipient and amount."
              source="Elections Canada — Political Financing Transparency Reports."
            />
          } />
          <Route path="/projects" element={
            <PlaceholderDataset
              slug="projects"
              kicker="Auditor flagged"
              title="Projects with cost overruns"
              blurb="Federal and provincial projects flagged in audit reports for a documented cost increase relative to the original budget. Each row links to the audit it was drawn from."
              source="Office of the Auditor General of Canada and provincial Auditors-General (ON, QC, BC, AB)."
            />
          } />
          <Route path="/public-sector" element={
            <PlaceholderDataset
              slug="public-sector"
              kicker="Public sector"
              title="Public sector employment"
              blurb="Canadian public sector employee jobs as Statistics Canada reports them, with OECD figures alongside for international context. Headline is headcount, not full-time equivalent."
              source="Statistics Canada Table 14-10-0026-01 and OECD Government at a Glance 2025."
            />
          } />
          <Route path="/all-time" element={
            <PlaceholderDataset
              slug="mp-expenses"
              kicker="All-time"
              title="Lifetime claims, since 2017"
              blurb="Every claim across every published quarter, ranked by total, by per-year average, and by claim line. Inflation adjustment available via the Today's dollars toggle."
              source="House of Commons of Canada — Members' Expenditures Report (quarterly archive)."
            />
          } />
          <Route path="/outliers" element={
            <PlaceholderDataset
              slug="mp-expenses"
              kicker="Outliers"
              title="Notable outliers"
              blurb="Parliamentarians whose claim profile sits more than two standard deviations from their party median in a given category."
              source="House of Commons Members' Expenditures Report · Spill the Hill derived."
            />
          } />
          <Route path="/categories" element={
            <PlaceholderDataset
              slug="mp-expenses"
              kicker="Categories"
              title="Spending by category"
              blurb="Travel, office expenditures, employee salaries, hospitality and events, office facilities — each ranked separately so the discretionary lines surface on their own."
              source="House of Commons Members' Expenditures Report."
            />
          } />
          <Route path="/compare" element={
            <PlaceholderDataset
              slug="mp-expenses"
              kicker="Compare"
              title="Compare two parliamentarians"
              blurb="Side-by-side breakdown of claims, eight-quarter trends and largest discretionary lines."
              source="House of Commons Members' Expenditures Report."
            />
          } />
          <Route path="/explore" element={
            <PlaceholderDataset
              slug="mp-expenses"
              kicker="Explore"
              title="Explore the data"
              blurb="Filter, sort and slice every published row. Export to CSV with source links preserved."
              source="House of Commons of Canada, Elections Canada, Statistics Canada, Open Government Canada."
            />
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
